// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ELDi","content":"styles_content__2Tl5i"};